import React, { memo, FC, useCallback, useRef } from "react";

import {
  IconLoaderBodyStyled,
  TextHelperStyled,
  FileInputStyled,
  TextFormatLoaderStyled,
  FilePickerStyled,
} from "./styles";

import { ReactComponent as EmptyIcon } from "../../assets/emptyIcon.svg";
import { IconLoaderProps } from "../../types";
import { DragAndDropIconHOC } from "../DragAndDropIconHOC";

export const AddIconLoader: FC<IconLoaderProps> = memo(({ setImageFile }) => {
  const fileInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const handleFilePicker = useCallback(() => {
    fileInputRef.current.click();
  }, []);
  const handlerLoadIcon = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      event.preventDefault();
      setImageFile(event.target.files?.[0] || null);
    },
    []
  );

  return (
    <DragAndDropIconHOC setImageFile={setImageFile}>
      {(isDragActive) => (
        <IconLoaderBodyStyled isDragActive={isDragActive}>
          <EmptyIcon />
          <TextHelperStyled>
            Drop your image here, or
            <FilePickerStyled onClick={handleFilePicker}>
              browse
            </FilePickerStyled>
            <FileInputStyled
              ref={fileInputRef}
              onChange={handlerLoadIcon}
              type="file"
              accept="image/*,.png,.jpg,.svg+xml,.svg,"
            />
          </TextHelperStyled>
          <TextFormatLoaderStyled>Supports: JPG,PNG,SVG</TextFormatLoaderStyled>
        </IconLoaderBodyStyled>
      )}
    </DragAndDropIconHOC>
  );
});
